export default "__VITE_ASSET__C6PYzw0P__"